module.exports = __webpack_public_path__ + "static/img/图层 514.7a9d67e7.png";